import { Flex, Typography } from 'antd'
import {
  ProviderClient,
  ProviderClientAction,
} from '~/plugins/data-connector/providers/abstract/provider.client'

type Props = {
  provider: ProviderClient
  action: ProviderClientAction
}

export const ProviderActionLabel: React.FC<Props> = ({ provider, action }) => {
  return (
    <Flex gap={8} align="center">
      <Typography.Text ellipsis style={{ color: 'inherit' }}>
        {action.label}
      </Typography.Text>
    </Flex>
  )
}
